import { Action, ACTION_TYPE, ERROR_CODE } from '@abiglobalhealth/go-types'

import { actionsRequest } from '@/api/utils'

export const getConfig = async <T extends Action<ACTION_TYPE.GET_CONFIG>>(): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload: {},
    type: ACTION_TYPE.GET_CONFIG
  })

  if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

  const { config } = body.data

  return {
    config
  }
}
